





































































import Vue from 'vue'
import _ from 'lodash'
import {ResourceDenfinitionServiceProxy} from '@/service-proxies/app-v2/api.service-proxies'
import {MasterlinkMenuServiceProxy} from '@/service-proxies/app-v2/system.service-proxies'

const menuServiceProxy = new MasterlinkMenuServiceProxy()

const resourceDenfinitionServiceProxy = new ResourceDenfinitionServiceProxy()

export default Vue.extend({
  name: 'AddPermission',
  props: {
    visible: { // 是否展示
      type: Boolean,
      default: false
    },
    appInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    menuId: {
      type: String
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      formData: {
        httpMethod: '',
        scopePath: '',
        scopeName: '',
        resourceCode: ''
      },
      remark: '', // 暂时不传,后端无对应字段
      appCode: '',
      interfaceName: '',
      fetching: false,
      loading: false,
      serviceList: [],
      apiList: [],
      apiItemList: [],
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.formData = {
          httpMethod: '',
          scopePath: '',
          scopeName: '',
          resourceCode: ''
        }
        this.remark = ''
        this.appCode = ''
        this.interfaceName = ''
      },
      immediate: true
    }
  },
  created() {
    this.getServiceList = _.debounce(this.getServiceList, 800)
  },
  methods: {
    handleCancel() {
      this.$emit('close')
    },
    handleOk() {
      this.loading = true
      let params: any = {
        menuId: this.menuId,
        ...this.formData
      }
      menuServiceProxy.updateApisInMenu(params).then((res:any) => {
        // console.log('新增权限：', res)
        this.loading = false
        if(res) {
          this.$message.success('新增成功！')
          this.$emit('close', true)
        }
      }, (err: any) => {
        this.loading = false
      })
    },
    handleServiceChange(value: any) {
      console.log(`appCode:`, this.appCode)
    },
    handleApiChange(value: any) {
      if (value) {
        this.apiItemList.map((item: any) => {
          if (item.code === value) {
            // console.log('item:', item)
            let {httpMethod, code, url, name} = item
            this.formData.httpMethod = httpMethod
            this.formData.resourceCode = code
            this.formData.scopeName = name
            this.formData.scopePath = url
          }
        })
      }
    },
    getServiceList(value: any) {
      this.serviceList = []
      this.fetching = true
      resourceDenfinitionServiceProxy.selectResourceDefinitionByAppCode(value).then((res: any) => {
        // console.log(res)
        this.fetching = false
        if (res) {
          this.serviceList = res
        }
      }, (err: any) => {
        this.fetching = false
      })
    },
    getApiList(value: any) {
      if (!this.appCode) {
        this.$message.error('请先选择服务!')
      }
      this.apiList = []
      this.apiItemList = []
      this.fetching = true
      resourceDenfinitionServiceProxy.queryResourceInfo(this.appCode, value).then((res: any) => {
        // console.log(res)
        this.fetching = false
        if (res) {
          this.apiItemList = res
          let tempArr: any = []
          res.map((item: any) => {
            tempArr.push(item.code)
          })
          this.apiList = [...tempArr]
        }
      }, (err: any) => {
        this.fetching = false
      })
    }
  }
})
